import { getPauseState } from '@/components/manageSubscription/Pause/util';
import { useUserState } from '@/hooks/store';

export const useUpsellUserState = () => {
	const user = useUserState();

	if (!user) return 'loggedOut';
	// An actively-paused subscriber reads as `valid: false`, but
	// they are not churned — their subscription auto-resumes at the end of
	// the pause. Without this branch they'd classify as neverTrialed /
	// churnedAndTrialed and be marketed a new plan, which would stack a
	// second subscription on top of the paused one. Scheduled pauses keep
	// normal treatment (the user retains access until `paused_starts_at`).
	if (getPauseState(user.subscription) === 'active') return 'paused';
	if (!user.subscription?.valid && !user.subscription?.has_ever_done_free_trial) return 'neverTrialed';
	if (user.subscription && user.subscription.has_ever_done_free_trial && !user.subscription.valid)
		return 'churnedAndTrialed';

	return 'activeCalmPremiumUser';
};
